import { TableFeatures } from '@/shared/lib/table';

export const histogramsTableFeatures: TableFeatures<never> = {
	pagination: {
		enabled: true,
		initialPage: 1,
		initialPageSize: 50,
	},
};
